import { TextField } from "@mui/material";
import transformDateToDe from "../../../functions/transformDateToDe";

interface StartOfQualificationProps {
  disabled?: boolean;
  required?: boolean;
  startOfQualification: string;
  endOfQualification: string;
  minDate?: string;
  showValidation?: boolean;
  onBlur?: () => void;
  setStartOfQualification: (startOfQualification: string) => void;
}

const StartOfQualification = ({
  disabled,
  required,
  startOfQualification,
  endOfQualification,
  minDate,
  setStartOfQualification,
  showValidation = true,
  onBlur,
}: StartOfQualificationProps): React.JSX.Element => {
  const isBeforeMinDate =
    minDate !== undefined &&
    startOfQualification.length > 0 &&
    startOfQualification < minDate;

  const isInvalid =
    startOfQualification.length === 0 ||
    endOfQualification.length === 0 ||
    startOfQualification > endOfQualification ||
    isBeforeMinDate;
  const showError = showValidation && isInvalid;

  const renderHelperText = () => {
    if (!showError) {
      return "";
    } else if (startOfQualification.length === 0) {
      return "Bitte gib ein Datum ein";
    } else if (isBeforeMinDate) {
      return `Das Datum darf nicht vor dem ${transformDateToDe(minDate)} liegen`;
    } else if (endOfQualification.length === 0) {
      return "Bitte gib ein Enddatum ein";
    } else if (startOfQualification > endOfQualification) {
      return "Das Startdatum muss vor dem Enddatum liegen";
    } else {
      return "";
    }
  };

  return (
    <TextField
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: isInvalid ? "1px !important" : "2px !important",
        },
        "& .MuiInputBase-root": {
          color: showError
            ? (theme) => theme.palette.error.main
            : !isInvalid
              ? (theme) => theme.palette.success.main
              : startOfQualification.length === 0
                ? // Match the label colour of the other empty fields for "tt.mm.jjjj".
                  (theme) => theme.palette.text.secondary
                : undefined,
        },
      }}
      disabled={disabled}
      color="success"
      required={required}
      fullWidth
      type="date"
      focused={!isInvalid}
      InputLabelProps={{ shrink: true }}
      value={startOfQualification}
      inputProps={{ min: minDate }}
      id="StartOfQualification"
      label="Anfang der Qualifizierung"
      variant="outlined"
      onChange={(event) => setStartOfQualification(event.target.value)}
      onBlur={onBlur}
      error={showError}
      helperText={renderHelperText()}
    />
  );
};

export default StartOfQualification;
